export const airbrake = {
    name: 'Airbrake',
    key: 'airbrake',
    assets: {
        icon: '/images/competitors/airbrake.svg',
    },
    products: {
        error_tracking: {
            available: true,
            features: {
                console_log_capture: true,
                error_alerts: true,
                exception_capture: true,
                issue_management: true,
                error_grouping: true,
                stack_tracing: true,
                mobile_sdk_coverage: true,
                source_map_support: true,
                user_device_context: true,
            },
            monitoring: {
                features: {
                    cron_monitoring: false,
                    release_tracking: true,
                    performance_monitoring: true,
                },
            },
            integrations: {
                ab_experiments: false,
                datadog: false,
                product_analytics: false,
                session_replay: false,
            },
        },
    },
    platform: {
        deployment: {
            eu_hosting: false,
            managed_reverse_proxy: false,
            open_source: false,
            self_host: false,
            ci_cd_integrations: true,
        },
        pricing: {
            free_tier: true,
            transparent_pricing: true,
            usage_based_pricing: true,
        },
        developer: {
            api: true,
            collaboration: true,
            mobile_sdks: true,
            native_data_sources: false,
            proxies: false,
            sdks: true,
            server_side_sdks: true,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            azure_blob: false,
            bigquery: false,
            cdp: false,
            ci_cd_integrations: true,
            community_integrations: false,
            csv_exports: false,
            customer_io: false,
            data_warehouse: false,
            email_reports: false,
            exports: false,
            gcs: false,
            google_ads: false,
            hubspot: false,
            imports: false,
            intercom: false,
            microsoft_teams: true,
            redshift: false,
            rudderstack: false,
            s3: false,
            salesforce: false,
            segment: false,
            sentry: false,
            slack: true,
            snowflake: false,
            stripe: false,
            warehouse_import: false,
            wordpress: false,
            zapier: true,
            zendesk: false,
        },
        security: {
            bot_blocking: false,
            cookieless_tracking: false,
            data_anonymization: true,
            data_retention: true,
            gdpr_ready: true,
            hipaa_ready: false,
            history_audit_logs: false,
            reverse_proxy: false,
            saml_sso: true,
            soc2_certified: true,
            two_factor_auth: true,
            user_privacy_options: true,
        },
        analytics_integration: {
            built_in_analytics: false,
        },
    },
    pricing: {
        model: 'Usage-based (errors)',
    },
}
